import axios from 'axios';

import router from '../router';
import store from '../store'

export default {
    refreshUserToken: context => {
        const {getSecuredRequestHeader} = context.getters;
        axios.post(`${process.env.VUE_APP_API_URL}/refresh-token`, {}, {headers: getSecuredRequestHeader})
            .then(response => {
                context.commit("saveUserToken", response.data.token)
            })
    },
    fetchUserDataIfLoggedIn: context => {
        const {isAuthenticated, getSecuredRequestHeader} = context.getters;
        if (isAuthenticated) {
            axios.get(`${process.env.VUE_APP_API_URL}/me`, {headers: getSecuredRequestHeader})
                .then((response) => {
                    store.commit('saveUserData', response.data);
                    store.dispatch('refreshUserToken');
                })
                .catch(() => {
                    router.push("/wyloguj-sie");
                })
        }
    }
}
